import React, { useEffect, useState } from 'react';
import { UploadProvider } from 'context/UploadVideoContext';
import VideoAnalysis from './VideoAnalysis';
import VideoAnalysisSubmission from './VideoAnalysisSubmission';
import VideoSuccessFailure from './VideoSuccessFailure';
import CreateAccount from '../LessonScheduler/CreateAccount';
import Login from '../LessonScheduler/Login';
import PaymentForm from '../LessonScheduler/PaymentForm';
import ResultForm from '../LessonScheduler/ResultForm';
import { Coach, Steps, VideoAnalysisSubmissionType } from '../types';

interface RemoteLessonSchedulerProps {
  coach: Coach;
  showTabSwitch?: boolean;
  setShowTabSwitch?: (showTabSwitch: boolean) => void;
  steps: Steps;
  setSteps: React.Dispatch<React.SetStateAction<Steps>>;
  handleClose?: () => void;
}

const RemoteLessonBooking: React.FC<RemoteLessonSchedulerProps> = ({
  coach,
  setShowTabSwitch,
  steps,
  setSteps,
  handleClose,
}) => {
  const [bookedLessonId, setBookedLessonId] = useState<string | null>(null);
  const [submissionData, setSubmissionData] = useState<VideoAnalysisSubmissionType>();

  useEffect(() => {
    if (setShowTabSwitch) {
      if (steps === Steps.VideoUploader) {
        setShowTabSwitch(true);
      } else {
        setShowTabSwitch(false);
      }
    }
  }, [steps, setShowTabSwitch]);

  useEffect(() => {
    setSteps(Steps.VideoUploader);
  }, []);

  return (
    <section className="flex flex-col rounded-xl  bg-color-bg-lightmode-primary dark:bg-color-bg-darkmode-primary">
      {steps === Steps.CreateAccount && (
        <CreateAccount
          setSteps={setSteps}
          handleNext={() => {
            setSteps(Steps.VideoUploader);
          }}
        />
      )}
      {steps === Steps.Login && (
        <Login
          setSteps={setSteps}
          handleNext={() => {
            setSteps(Steps.VideoUploader);
          }}
        />
      )}

      <UploadProvider>
        {steps === Steps.VideoAnalysis && <VideoAnalysis coach={coach} setSteps={setSteps} />}
        {steps === Steps.VideoUploader && (
          <VideoAnalysisSubmission
            coach={coach}
            setSteps={setSteps}
            setSubmissionData={setSubmissionData}
            handleClose={handleClose}
          />
        )}
        {steps === Steps.VideoSuccessFailure && <VideoSuccessFailure setSteps={setSteps} />}
      </UploadProvider>

      {steps === Steps.PaymentForm && (
        <div className="pt-6">
          <PaymentForm
            setBookedLessonId={setBookedLessonId}
            setSteps={setSteps}
            coach={coach}
            isRemoteCoaching={true}
            remoteCoachData={submissionData}
            handleClose={handleClose}
          />
        </div>
      )}
      {steps === Steps.ResultForm && (
        <div className="py-5">
          <ResultForm
            bookedLessonId={bookedLessonId}
            setSteps={setSteps}
            coach={coach}
            isRemoteCoaching={true}
          />
        </div>
      )}
    </section>
  );
};

export default RemoteLessonBooking;
